import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useState } from 'react';
import NoodleMask from "./NoodleMask";
import SpinnerApple from "../ui/spinner/Spinner.Apple";
import { math } from "noood/util/math/math";
import NoodleModalContentFromAPIResponse from "./noodle-modal/NoodleModalContentFromAPIResponse";
import { NoodleModalTemplates } from "./noodle-modal/NoodleModalTemplates";
import * as stylex from "@stylexjs/stylex";
import Icon from "noood/comp/ui/feather-icon/Icon";
import Flex from "noood/comp/ui/containers/Flex";
import { styling } from "noood/styles/styles.stylex";
import Row from "noood/comp/ui/containers/flex-boxes/Row";
import { NoodleModalContext } from './NoodleModalProvider';
export default function NoodleModal(props) {
  var _props$settings, _settings$primary, _settings$width, _settings$secondary$i, _settings$secondary2, _settings$secondary$l, _settings$secondary3;
  var _useState = useState("30px"),
    _useState2 = _slicedToArray(_useState, 2),
    top = _useState2[0],
    setTop = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    isProcessing = _useState4[0],
    setIsProcessing = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    settings = _useState6[0],
    setSettings = _useState6[1];
  var _useContext = useContext(NoodleModalContext),
    __closeModal = _useContext.__closeModal,
    __replace = _useContext.__replace;
  var primaryButton = (_props$settings = props.settings) === null || _props$settings === void 0 ? void 0 : _props$settings.primary;
  var primaryClasses = [];
  if ((_settings$primary = settings.primary) !== null && _settings$primary !== void 0 && _settings$primary.nature) {
    switch (settings.primary.nature) {
      case "negative":
        break;
      default:
        break;
    }
  }
  useEffect(function () {
    setSettings(props.settings);
    return function () {};
  }, [props.settings]);
  useEffect(function () {
    setTop("50px");
    function handleKeyUp(event) {
      switch (event.key) {
        case "Escape":
          console.log("isProcessing: ", isProcessing);
          if (!isProcessing) {
            __closeModal(props.index);
          }
          break;
      }
    }
    window.addEventListener("keyup", handleKeyUp);
    return function () {
      return window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);
  var onAfterDo = function onAfterDo(apiResponse, onAfterDoCallback, settingsOverride) {
    __replace(props.index, /*#__PURE__*/React.createElement(NoodleModalContentFromAPIResponse, {
      response: apiResponse
    }), _objectSpread(_objectSpread({}, props.settings), {}, {
      primary: _objectSpread(_objectSpread({}, NoodleModalTemplates.button.ok), {}, {
        __do: function __do(thisIndex, operations) {
          if (onAfterDoCallback) {
            __closeModal(thisIndex);
            onAfterDoCallback();
          } else {
            __closeModal(thisIndex);
          }
        }
      }, settingsOverride === null || settingsOverride === void 0 ? void 0 : settingsOverride.primary),
      secondary: undefined,
      promptType: "INFO"
    }));
  };
  var onAffirm = function onAffirm(modalIndex, onAffirmativeCallback) {
    __closeModal(modalIndex);
    onAffirmativeCallback === null || onAffirmativeCallback === void 0 || onAffirmativeCallback();
  };
  var onAfterAck = function onAfterAck(callbackAction) {
    callbackAction === null || callbackAction === void 0 || callbackAction();
  };
  var setNewSettings = function setNewSettings(_ref) {
    var newSettings = _ref.settings;
    setSettings(_objectSpread(_objectSpread({}, settings), newSettings));
  };

  // @ts-ignore
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NoodleMask, {
    index: props.index
  }), /*#__PURE__*/React.createElement("div", _extends({
    style: {
      top: top,
      width: "".concat((_settings$width = settings.width) !== null && _settings$width !== void 0 ? _settings$width : 400, "px"),
      left: "50%",
      marginLeft: "".concat(settings.width ? math.round(settings.width / 2, 0) * -1 : '-200', "px"),
      zIndex: 500 + props.index + 1,
      boxShadow: "0 10px 60px rgba(0,0,0,.3)",
      transition: "all 0.2s cubic-bezier(.23,1.03,.67,.99)",
      overflow: "hidden",
      borderRadius: "var(--roundness)",
      backgroundColor: "var(--shade-light)"
    }
  }, {
    className: "NoodleModal__ui.container evixxii4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ui-modal-title-row",
    style: {
      backgroundColor: "var(--shade)",
      borderTopLeftRadius: "var(--roundness)",
      borderTopRightRadius: "var(--roundness)",
      padding: "10px 20px",
      textAlign: "center",
      position: "relative",
      color: "var(--text)"
    }
  }, settings.title, !isProcessing && /*#__PURE__*/React.createElement("div", _extends({}, {
    className: "NoodleModal__ui.closeButton evytml03 ev10l6tqk ev19up5dg evfr5jun ev1h2kqdt ev1dfczft evfge0gx evorixrz evlzg99y evi0exxh ev78zum5 ev6s0dn4 evl56j7k"
  }, {
    onClick: function onClick(e) {
      return __closeModal(props.index);
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "x",
    color: "var(--shade-50)"
  }))
  /*<ColorIcon
    styling={{box: {position: `absolute`, right: '8px', top: `8px`}}}
    background_color={`transparent`}
    hoverBackgroundColor={`var(--shade-negative)`}
    icon={`x`} size={20} icon_color={`var(--shade-dark)`}
    __click={() => {
      __closeModal(props.index)
    }}
  />*/), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: "var(--shade-lightest)",
      padding: "20px"
    }
  }, props.content), (settings.primary || settings.secondary) && /*#__PURE__*/React.createElement("div", {
    className: "NoodleModal__ui.action_button_container ev7z7khe ev78zum5 ev6s0dn4 ev13a6bvl"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      paddingLeft: "10px"
    }
  }, isProcessing && /*#__PURE__*/React.createElement(SpinnerApple, null)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "10px"
    }
  }, settings.secondary && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", _extends({}, stylex.props(styling.button, ui.secondaryButton, isProcessing && ui.disabled), {
    disabled: isProcessing,
    onClick: function onClick(e) {
      var _settings$secondary, _settings$secondary$_;
      __closeModal(props.index);
      (_settings$secondary = settings.secondary) === null || _settings$secondary === void 0 || (_settings$secondary$_ = _settings$secondary.__do) === null || _settings$secondary$_ === void 0 || _settings$secondary$_.call(_settings$secondary, props.index);
    }
  }), /*#__PURE__*/React.createElement(Flex, {
    gap: 5,
    wrap: false
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    icon: (_settings$secondary$i = (_settings$secondary2 = settings.secondary) === null || _settings$secondary2 === void 0 ? void 0 : _settings$secondary2.icon) !== null && _settings$secondary$i !== void 0 ? _settings$secondary$i : 'x',
    color: isProcessing ? "var(--shade-10)" : "var(--shade-30)"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("nobr", null, (_settings$secondary$l = (_settings$secondary3 = settings.secondary) === null || _settings$secondary3 === void 0 ? void 0 : _settings$secondary3.label) !== null && _settings$secondary$l !== void 0 ? _settings$secondary$l : 'No'))))), settings.primary && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", _extends({}, stylex.props(styling.button, ui.primary_button, primaryButton.nature === "negative" && ui.negative, primaryButton.nature === "neutral" && ui.secondaryButton, isProcessing && ui.disabled), {
    disabled: isProcessing,
    onClick: function onClick() {
      var _primaryButton$__do;
      (_primaryButton$__do = primaryButton.__do) === null || _primaryButton$__do === void 0 || _primaryButton$__do.call(primaryButton, props.index, {
        onAfterDo: onAfterDo,
        setIsProcessing: setIsProcessing,
        onAffirm: onAffirm
      });
    }
  }), /*#__PURE__*/React.createElement(Row, {
    gap: 5
  }, primaryButton.icon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    icon: primaryButton.icon
  })), /*#__PURE__*/React.createElement("nobr", null, primaryButton.label), primaryButton.rightIcon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    icon: primaryButton.rightIcon
  })))))))));
}

// @ts-ignore
_inject(".evji57aj{background-color:var(--shade-10)}", 3000);
_inject(".ev1g19nhj{color:var(--shade-05)}", 3000);
_inject(".ev9r1u3d{border-color:transparent}", 2000);
_inject(".ev1h6gzvc{cursor:not-allowed}", 3000);
_inject(".evytml03{color:var(--shade-50)}", 3000);
_inject(".ev10l6tqk{position:absolute}", 3000);
_inject(".ev19up5dg{right:8px}", 4000);
_inject(".evfr5jun{top:8px}", 4000);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".ev1dfczft:hover{background-color:var(--shade-05)}", 3130);
_inject(".evfge0gx:active{background-color:var(--shade-10)}", 3170);
_inject(".evorixrz{border-radius:100%}", 2000);
_inject(".evlzg99y{width:23px}", 4000);
_inject(".evi0exxh{height:23px}", 4000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".evtv0qo8{border:1px solid var(--shade-10)}", 1000);
_inject(".evjbqb8w{background-color:transparent}", 3000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
_inject(".ev1ko5yus:active{background-color:var(--shade-20)}", 3170);
_inject(".ev1nlnu2n{transition:background-color .2s,border-color .2s}", 2000);
_inject(".ev1jo8pe8{color:var(--shade-30)}", 3000);
_inject(".ev1j61zf2{font-size:16px}", 3000);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".ev1tzx33q{color:var(--text-on-accent)}", 3000);
_inject(".ev13j9udk{background-color:var(--shade-negative)}", 3000);
_inject(".ev5zlb00:hover{background-color:var(--shade-negative-dark)}", 3130);
_inject(".ev1amtvsf:active{background-color:var(--shade-negative-darker)}", 3170);
_inject(".ev1b0nn0a{color:var(--text-on-shade-negative)}", 3000);
_inject(".ev7z7khe{padding:10px}", 1000);
_inject(".ev13a6bvl{justify-content:flex-end}", 3000);
_inject(".evixxii4{position:fixed}", 3000);
var ui = {
  disabled: {
    "NoodleModal__ui.disabled": "NoodleModal__ui.disabled",
    backgroundColor: "evji57aj",
    color: "ev1g19nhj",
    borderColor: "ev9r1u3d",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    cursor: "ev1h6gzvc",
    $$css: true
  },
  secondaryButton: {
    "NoodleModal__ui.secondaryButton": "NoodleModal__ui.secondaryButton",
    border: "evtv0qo8",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "evjbqb8w ev3dtjww ev1ko5yus",
    transition: "ev1nlnu2n",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    color: "ev1jo8pe8",
    fontSize: "ev1j61zf2",
    margin: "ev1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  primary_button: {
    "NoodleModal__ui.primary_button": "NoodleModal__ui.primary_button",
    color: "ev1tzx33q",
    $$css: true
  },
  negative: {
    "NoodleModal__ui.negative": "NoodleModal__ui.negative",
    backgroundColor: "ev13j9udk ev5zlb00 ev1amtvsf",
    color: "ev1b0nn0a",
    $$css: true
  }
};